export enum Environment {
    Dev = 'Dev',
    Local = 'Local',
    Test = 'Test',
}
